<script>
  import { changeToken } from '../../../Api';
  import { api } from '../../../helpers';

  import Loader from './../../custom/Loader.svelte';
  import PreviewCard from '../../custom/PreviewCard/PreviewCard.svelte';
  import GeneralLayout from '../../layouts/GeneralLayout.svelte';

  // Параметры роутера
  export let params = {};

  const getPublicateById = async (id) => {
    const response = await api(`/api/v1/publication/retrive/${id}/`);
    const publication = await response.json();

    if (!response.ok) {
      changeToken(response.status);
		}

    return publication;
  }
</script>

<GeneralLayout>
  {#await getPublicateById(params.publ_id)}
    <Loader />
  {:then publication}
    <PreviewCard {publication} />
  {/await}
</GeneralLayout>